import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';

import type { PackResponse } from 'app/typings/core/admin/packs/pack';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function usePack(id?: string | number) {
  const packId = id && !isNaN(Number(id)) ? id.toString() : undefined;

  const key = [CORE_QUERY_KEYS.pack, { id: packId }];

  return useQuery({
    queryKey: key,
    queryFn: packId
      ? () =>
          apiRequest({
            path: ENDPOINTS.getPack,
            params: { id: packId },
          }) as Promise<PackResponse>
      : () => Promise.resolve(undefined),
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    enabled: !!packId,
  });
}
